import { Component, inject, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { TooltipContext } from '@shared/directives/dynamic-portal-tooltip.directive';
import { BudgetSummaryBarViewMode } from '@shared/enums/budget-summary-bar-view.enum';
import { SummaryBarCalculationItem, SummaryBarItem } from '@shared/components/budget-summary-bar/budget-summary-bar.types';
import { summaryBarDefaultItems, tooltipContextList } from '@shared/components/budget-summary-bar/budget-summary-bar.helpers';
import { CustomAvailableBudgetConfigurationService } from 'app/custom-available-budget/custom-available-budget-configuration.service';

@Component({
  selector: 'custom-available-budget-summary-bar',
  templateUrl: './custom-available-budget-summary-bar.component.html',
  styleUrls: ['./custom-available-budget-summary-bar.component.scss']
})
export class CustomAvailableBudgetSummaryBarComponent implements OnInit {
  public summaryBarItems: SummaryBarItem[][] = summaryBarDefaultItems;
  public tooltipPosition: ConnectedPosition = {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    offsetY: -15
  };
  public tooltipContextList = tooltipContextList;
  public summaryBarCalculationItems: SummaryBarCalculationItem[] = [];
  private destroy$ = new Subject<void>();
  private readonly customAvailableBudgetConfigurationService = inject(CustomAvailableBudgetConfigurationService);
  currentManagePageFormula: string[] = [];  
  allowedSummaryBarCalculationItems: SummaryBarCalculationItem[] = [];

  @Input() set calculationItems(items: SummaryBarCalculationItem[]) {
    this.allowedSummaryBarCalculationItems = items;
  }
  
  @Input() summaryBarLoading$: BehaviorSubject<boolean>;
  @Input() summaryBarViewMode: BudgetSummaryBarViewMode;
  @Input() set summaryItems(items: SummaryBarItem[][]) {
    if (items) {
      this.summaryBarItems = items;
    }
  };


  ngOnInit(): void {
    this.customAvailableBudgetConfigurationService.managePageCustomAvailableBudgetFormulaItems$
    .pipe(takeUntil(this.destroy$))
    .subscribe((items) => {
      this.currentManagePageFormula = items;
      this.summaryBarCalculationItems = this.allowedSummaryBarCalculationItems.slice(0,-1).filter(item => this.currentManagePageFormula.includes(item.label));
      this.summaryBarCalculationItems.push(this.allowedSummaryBarCalculationItems[this.allowedSummaryBarCalculationItems.length - 1]);
    });
  }


  getSummaryBarTooltipContext(index: number): TooltipContext {
    if (!this.summaryBarViewMode) {
      return null;
    }
    return this.tooltipContextList[this.summaryBarViewMode][index];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
